module.exports = __webpack_public_path__ + "static/media/low_carbon_detail.06d31655.png";